/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* =====================
   Recherche prédictive INLINE (barre de recherche header)
   ===================== */
(function() {
  'use strict';

  class SearchInline {
    constructor(el) {
      this.wrapper    = el;
      this.input      = el.querySelector('.search-inline-input');
      this.dropdown   = el.querySelector('.search-inline-dropdown');
      this.form       = el.querySelector('.search-inline-form');
      this.timer      = null;
      this.lastQuery  = '';
      this.isOpen     = false;

      if (!this.input || !this.dropdown) return;

      this._bindEvents();
    }

    _bindEvents() {
      // Saisie avec débounce 280ms
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        const q = this.input.value.trim();
        if (!q) { this.close(); return; }
        this.timer = setTimeout(() => this.fetchResults(q), 280);
      });

      // Fermer si clic en dehors
      document.addEventListener('click', (e) => {
        if (!this.wrapper.contains(e.target)) this.close();
      });

      // Fermer sur Escape
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });

      // Réouvrir si focus + valeur présente
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim() && this.dropdown.innerHTML.trim()) {
          this.open();
        }
      });
    }

    async fetchResults(q) {
      if (q === this.lastQuery) { this.open(); return; }
      this.lastQuery = q;

      // Afficher spinner
      this.dropdown.innerHTML = '<div class="sil-loading"><span class="sil-spinner"></span></div>';
      this.open();

      try {
        const res = await fetch(
          `/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=search-predictive`,
          { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
        );
        if (!res.ok) throw new Error('fetch error');
        const text = await res.text();
        const doc  = new DOMParser().parseFromString(text, 'text/html');
        const products = doc.querySelectorAll('.product-item');

        if (!products.length) {
          this.dropdown.innerHTML = '<div class="sil-no-results">Aucun résultat trouvé</div>';
          this.open();
          return;
        }

        // Extraire les données produits depuis le DOM retourné
        let html = '<p class="sil-section-title">Produits</p><ul class="sil-product-list">';

        products.forEach(item => {
          const link     = item.querySelector('a[href]');
          const imgEl    = item.querySelector('img');
          const titleEl  = item.querySelector('.product-item-title a, .product-item-title');
          const priceEl  = item.querySelector('.product-item-price-final');
          const compareEl= item.querySelector('.product-item-price-compare s');

          const href     = link ? link.getAttribute('href') : '#';
          const img      = imgEl ? imgEl.getAttribute('src') : '';
          const title    = titleEl ? titleEl.textContent.trim() : '';
          const price    = priceEl ? priceEl.textContent.trim() : '';
          const compare  = compareEl ? compareEl.textContent.trim() : '';

          html += `
            <li>
              <a class="sil-product-item" href="${href}">
                ${img ? `<img class="sil-product-img" src="${img}" alt="${title}" loading="lazy">` : ''}
                <div class="sil-product-info">
                  <div class="sil-product-title">${title}</div>
                  <div>
                    <span class="sil-product-price">${price}</span>
                    ${compare ? `<span class="sil-product-price-compare">${compare}</span>` : ''}
                  </div>
                </div>
              </a>
            </li>`;
        });

        html += '</ul>';
        html += `<a class="sil-footer-link" href="/search?q=${encodeURIComponent(q)}&type=product">Voir tous les résultats pour &ldquo;${this._esc(q)}&rdquo; &rarr;</a>`;

        this.dropdown.innerHTML = html;
        this.open();

      } catch(err) {
        this.dropdown.innerHTML = '<div class="sil-no-results">Erreur lors de la recherche</div>';
        this.open();
      }
    }

    open()  { this.dropdown.classList.add('is-open');    this.isOpen = true; }
    close() { this.dropdown.classList.remove('is-open'); this.isOpen = false; }

    _esc(str) {
      return str.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }
  }

  // Initialisation au chargement
  function initSearchInline() {
    document.querySelectorAll('.search-inline-wrapper').forEach(el => {
      if (!el._searchInlineInit) {
        el._searchInlineInit = true;
        new SearchInline(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchInline);
  } else {
    initSearchInline();
  }

})();
